"use strict";

var curry = require('./curry.js');

var groupBy = require('./groupBy.js');

var go1 = require("./go1.js");

var pipe1 = require("./pipe1.js");

module.exports = curry(function partition(f, iter) {
  return go1(groupBy(pipe1(f, Boolean), iter), group => [group['true'] || [], group['false'] || []]);
});